import React from 'react';

function CartasFinanza(props) {

    return (
  <div className="row d-flex justify-content-between">
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
   <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        {props.titulo1}
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-center px-md-1">
        <span className='fw-bold text-center fs-4'>{props.total1}</span>
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
   <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-between px-md-1">
         
        </div>
      </div>
    </div>
  </div>
  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
   <div className="card bg-card-info mx-auto" style={{height:'90%',width:'80%'}}>
      <div className='card-header' style={{height:'80%'}}>
        Almacen
      </div>
      <div className="card-body bg-light mx-1 mb-1">
        <div className="d-flex justify-content-between px-md-1">
         
        </div>
      </div>
    </div>
  </div>
</div>

  );
}

export default CartasFinanza;


// WEBPACK FOOTER //
// ./src/components/finanzas/cartas.js